import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { connect } from 'react-redux'
import { Segment, Button, Header, Grid, Table } from 'semantic-ui-react'

import utils from '../../utils'
import MapViewActions from '../../reducers/mapViewReducer'

class CustomerMetric extends React.PureComponent {
  state = {
    customerCluster: [],
    allFoodValue: [],
    allDeliveryValue: [],
    allRestoCommission: [],
    allDeliveryCommission: [],
    allCommissionEarn: [],
    allRestoCommissionRate: [],
    orderDiscount: 0,
    promoCodeDiscount: 0,
    payingCustomerCount: 0,
    nonPayingCustomerCount: 0,
    filterDate: [],
  }

  componentDidMount() {
    const { orders } = this.props

    this.getCustomerMetric(orders)
  }

  componentWillReceiveProps(nextProps) {
    const { orders, customers } = this.props

    if (orders !== nextProps.orders || customers !== nextProps.customers) {
      this.getCustomerMetric(nextProps.orders, nextProps.customers)
      this.getDatesExcludeStartEnd(nextProps.startDate, nextProps.endDate)
    }
  }

  getDatesExcludeStartEnd = (startDate, endDate) => {
    const dateArray = []
    let afterStartDate = moment(startDate)
    const beforeEndDate = moment(endDate)

    while (afterStartDate < beforeEndDate) {
      dateArray.push(moment(afterStartDate).format('YYYY-MM-DD'))
      afterStartDate = moment(afterStartDate).add(1, 'days')
    }

    this.setState({ filterDate: dateArray })
  }

  getClusterLocation = (order, orderKey) => {
    const { lat: customerLatitude, lng: customerLongitude } = order.etaInfo.info.legs[0].end_location

    return {
      latitude: customerLatitude,
      longitude: customerLongitude,
      orderKey,
    }
  }

  getCustomerMetric = (orders, customers) => {
    const customerCluster = []
    const allFoodValue = []
    const allDeliveryValue = []
    const allRestoCommission = []
    const allDeliveryCommission = []
    const allCommissionEarn = []
    const allRestoCommissionRate = []
    const payingCustomerCount = _.filter(customers, customer => (customer.delivered_order_count || 0) > 0)
      .length
    const customerCount = _.size(customers)
    const nonPayingCustomerCount = customerCount - payingCustomerCount
    let orderDiscount = 0
    let promoCodeDiscount = 0

    _.map(orders, (order, orderKey) => {
      if (order.status === 'delivered') {
        const deliveryValue = Number(order.delivery_fee)
        const foodValue = Number(order.sub_total)
        const restoCommission = utils.order.getOrderCommissionFee(order)
        const deliveryCommission = utils.order.getOrderDeliveryCommissionFee(order)
        const earnCommission = Number(parseFloat(restoCommission + deliveryCommission).toFixed(2))
        const restoCommissionRate = Number(order.discount_rate)

        promoCodeDiscount += order.voucher ? order.voucher.order.discount_amount / 100 : 0
        orderDiscount += order.promotion_discount
        allFoodValue.push(foodValue)
        allDeliveryValue.push(deliveryValue)
        allRestoCommission.push(restoCommission)
        allDeliveryCommission.push(deliveryCommission)
        allCommissionEarn.push(earnCommission)
        allRestoCommissionRate.push(restoCommissionRate)
      }

      const cluster = this.getClusterLocation(order, orderKey)
      customerCluster.push(cluster)
    })

    this.setState({
      customerCluster,
      allFoodValue,
      allDeliveryValue,
      allRestoCommission,
      allDeliveryCommission,
      allCommissionEarn,
      allRestoCommissionRate,
      nonPayingCustomerCount,
      payingCustomerCount,
      promoCodeDiscount: Number(parseFloat(promoCodeDiscount).toFixed(2)),
      orderDiscount: Number(parseFloat(orderDiscount).toFixed(2)),
    })
  }

  showCluster = () => {
    const { customerCluster } = this.state
    const { setMapData } = this.props

    setMapData('customer_zone', customerCluster)
  }

  renderRow = (
    date,
    payingCustomerCount,
    nonPayingCustomerCount,
    orderCount,
    completedOrderCount,
    rejectedOrderCount,
    promoCodeDiscount,
    orderDiscount,
    foodValueTotal,
    deliveryValueTotal,
    merchantCommissionTotal,
    deliveryCommissionTotal,
    commissionEarnTotal,
    commissionRateTotal,
    totalEarnTotal
  ) => {
    this.render(
      <Table.Row>
        <Table.Cell>{date}</Table.Cell>
        <Table.Cell>{orderCount}</Table.Cell>
        <Table.Cell>{completedOrderCount}</Table.Cell>
        <Table.Cell>{rejectedOrderCount}</Table.Cell>
        <Table.Cell>Total Paying Customer</Table.Cell>
        <Table.Cell>{foodValueTotal}</Table.Cell>
        <Table.Cell>{merchantCommissionTotal}</Table.Cell>
        <Table.Cell>{deliveryValueTotal}</Table.Cell>
        <Table.Cell>{deliveryCommissionTotal}</Table.Cell>
        <Table.Cell>{commissionEarnTotal}</Table.Cell>
        <Table.Cell>{commissionRateTotal}</Table.Cell>
        <Table.Cell>Total Earn Commission</Table.Cell>
        <Table.Cell>{payingCustomerCount}</Table.Cell>
        <Table.Cell>{nonPayingCustomerCount}</Table.Cell>
        <Table.Cell>{orderDiscount}</Table.Cell>
        <Table.Cell>{promoCodeDiscount}</Table.Cell>
      </Table.Row>
    )
  }

  renderNoRecord = () => {
    return (
      <Table.Row>
        <Table.Cell textAlign="center" colSpan="16">
          No results
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const {
      customerCluster,
      allFoodValue,
      allDeliveryValue,
      allRestoCommission,
      allDeliveryCommission,
      allCommissionEarn,
      allRestoCommissionRate,
      payingCustomerCount,
      nonPayingCustomerCount,
      promoCodeDiscount,
      orderDiscount,
    } = this.state
    const foodValue = Number(parseFloat(_.mean(allFoodValue)).toFixed(2)) || 0
    const deliveryValue = Number(parseFloat(_.mean(allDeliveryValue)).toFixed(2)) || 0
    const restoCommission = Number(parseFloat(_.mean(allRestoCommission)).toFixed(2)) || 0
    const deliveryCommission = Number(parseFloat(_.mean(allDeliveryCommission)).toFixed(2)) || 0
    const commissionEarn = Number(parseFloat(_.mean(allCommissionEarn)).toFixed(2)) || 0
    const commissionRate = Number(parseFloat(_.mean(allRestoCommissionRate)).toFixed(2)) || 0
    const totalEarn = Number(parseFloat(_.sum(allCommissionEarn)).toFixed(2)) || 0

    return (
      <Segment>
        <Header size="large">
          Customer
          <Button
            style={{ float: 'right' }}
            onClick={this.showCluster}
            disabled={_.size(customerCluster) === 0}
          >
            Customer Zone
          </Button>
        </Header>

        <Grid columns="equal" style={{ marginTop: 10 }}>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Order value (AVG)</Header>
              <Header size="medium">{`$ ${foodValue}`}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Order commission (AVG)</Header>
              <Header size="medium">{`$ ${restoCommission}`}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Delivery value (AVG)</Header>
              <Header size="medium">{`$ ${deliveryValue}`}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Delivery commission (AVG)</Header>
              <Header size="medium">{`$ ${deliveryCommission}`}</Header>
            </Segment>
          </Grid.Column>
        </Grid>
        <Grid columns="equal" style={{ marginTop: 10 }}>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Restaurant commission rate (AVG)</Header>
              <Header size="medium">{`% ${commissionRate}`}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Earn commission (AVG)</Header>
              <Header size="medium">{`$ ${commissionEarn}`}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Total earn commission</Header>
              <Header size="medium">{`$ ${totalEarn}`}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Total Discount Amount</Header>
              <Header size="medium">{`$ ${orderDiscount}`}</Header>
            </Segment>
          </Grid.Column>
        </Grid>
        <Grid columns="equal" style={{ marginTop: 10 }}>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Total Promo code Discount Amount</Header>
              <Header size="medium">{`$ ${promoCodeDiscount}`}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Total New paying customers</Header>
              <Header size="medium">{payingCustomerCount}</Header>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment textAlign="center">
              <Header size="medium">Total New Non-paying customers</Header>
              <Header size="medium">{nonPayingCustomerCount}</Header>
            </Segment>
          </Grid.Column>
        </Grid>
      </Segment>
    )
  }
}

const mapState = ({ dashboard }) => ({
  orders: dashboard.dashboardOrders,
  customers: dashboard.dashboardCustomers,
  startDate: dashboard.orderStartAt,
  endDate: dashboard.orderEndAt,
})

const mapDispatch = {
  setMapData: MapViewActions.setMapData,
}

export default connect(
  mapState,
  mapDispatch
)(CustomerMetric)



// WEBPACK FOOTER //
// ./src/components/Dashboard/CustomerMetric.js